import React from 'react';
import { Pressable, View, Text, StyleSheet } from 'react-native';
import { RadioButton } from 'react-native-paper';
import { MIN_TAP_TARGET, useIsNarrowForm, } from '../intakeForm/ResponsiveFormContext';
export const YesNoRadioGroup = (props) => {
    // Phone-sized public sign-up only: question above, 44pt answer targets.
    const narrow = useIsNarrowForm();
    const onValueChange = (value) => {
        // Convert string to boolean
        const newValue = value === 'true' ? true : value === 'false' ? false : undefined;
        // Create a synthetic event to work with Formik's handleChange
        const syntheticEvent = {
            target: {
                name: props.valueName, // Set the name for the field (as expected by Formik)
                value: newValue, // The new value (true/false)
            },
        };
        // Call Formik's handleChange with the synthetic event
        props.handleChange(syntheticEvent);
    };
    const groupValue = props.value === true ? 'true' : props.value === false ? 'false' : ''; // Convert boolean to string for RadioButton
    const options = [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
    ];
    return (<View style={narrow ? styles.stacked : styles.row}>
      <Text style={styles.radioLabelText}>{props.labelText}</Text>
      <RadioButton.Group onValueChange={onValueChange} value={groupValue}>
        <View style={[
            styles.row,
            props.readOnly
                ? styles.pointerEventsNone
                : styles.pointerEventsAuto,
        ]}>
          {options.map(option => narrow ? (<Pressable key={option.value} accessibilityRole="radio" accessibilityState={{ checked: groupValue === option.value }} onPress={() => onValueChange(option.value)} style={styles.narrowOption}>
                <RadioButton value={option.value}/>
                <Text style={styles.narrowOptionText}>{option.label}</Text>
              </Pressable>) : (<View key={option.value} style={styles.row}>
                <RadioButton value={option.value}/>
                <Text style={styles.radioItemText}>{option.label}</Text>
              </View>))}
        </View>
      </RadioButton.Group>
    </View>);
};
const styles = StyleSheet.create({
    radioLabelText: {
        marginTop: 8,
        marginLeft: 10,
        fontWeight: 'bold',
    },
    radioItemText: {
        marginTop: 8,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    stacked: {
        flexDirection: 'column',
    },
    narrowOption: {
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: MIN_TAP_TARGET,
        marginRight: 16,
    },
    narrowOptionText: {
        fontSize: 16,
    },
    pointerEventsNone: { pointerEvents: 'none' },
    pointerEventsAuto: { pointerEvents: 'auto' },
});
